import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import logo from "../assets/images/newimgs/logo.png";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import "../assets/css/style.css";
import DigitalRaizpdf from "../assets/images/office/DIGITALRAIZ PROFILE.pdf";
import DigitalraizCreativeSolutions from "../assets/images/office/DIGITAL MARKETING PORTFOLIO.pdf";
import MobilePortfolio from "../assets/images/office/MobileAppPortfolio.pdf";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [form, setform] = useState({
    name: "",
    phone: "",
    email: "",
    projectname: "",
    aboutproject: "",
    lookingfor: "",
    location: "",
    service: "Mobile Application",
  });
  const location = useLocation();
  const careerPage = location.pathname === "/career";
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(careerPage ? false : true);

  const [sticky, setSticky] = useState("");

  useEffect(() => {
  const isSubmitted = localStorage.getItem("formSubmitted");
  if (!isSubmitted) {
    setTimeout(() => {
      handleShow();
    }, 1000);
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
  window.addEventListener("scroll", isSticky);
  return () => {
    window.removeEventListener("scroll", isSticky);
  };
}, []);


  const isSticky = () => {
    const scrollTop = window.scrollY;
    const screenWidth = window.innerWidth;
    let stickyClass = "";
    if (screenWidth < 768) {
      stickyClass = scrollTop >= 0 ? "header-area sticky" : "";
    } else {
      stickyClass = scrollTop >= 50 ? "header-area sticky" : "";
    }

    setSticky(stickyClass);
    console.log(stickyClass);
  };

  const classes = `${sticky}`;

  const settings1 = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    width: 500,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  const handlechange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const addUsers = () => {
    var params = {
      name: form.name,
      phone: form.phone,
      email: form.email,
      service: form.service,
      lookingfor: form.lookingfor,
      location: form.location,
      aboutproject: form.aboutproject,
      projectname: form.projectname,
    };
    axios
      .post("https://api.digitalraiz.co.in/api/user/leads/addLead", params, {})
      .then(
        (res) => {
          if (res.status === 200) {
              localStorage.setItem("formSubmitted", "true");
            toast.success(
              "Added Successfully. Your data received, Our team will get back to you soon!"
            );
            handleClose();
            navigate("/thankyou");
          }
        },
        (error) => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message);
          }
        }
      );
  };

  const usersSubmit = (e) => {
    e.preventDefault();
    addUsers();
  };

  return (
    <div>
      <header className={classes} id="header-area">
        <nav className="navbar navbar-expand-md fixed-top mobileOpens">
          <div className="container">
            <div className="site-logo">
              <NavLink to="/" className="navbar-brand">
                <img src={logo} className="img-fluid moblogoimg" alt="Img" />
              </NavLink>
            </div>

            <div className="d-flex">
              <a
                href="tel:+1234567890"
                className="mobile-callIcon mt-1 d-lg-none d-inline-block"
              >
                <i className="fas fa-phone mobile-innercalIcon" />
              </a>

              {!careerPage && (
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarCollapse"
                  aria-controls="navbarCollapse"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon">
                    <i
                      className="fas fa-bars"
                      style={{ color: "#901ec1", fontSize: "24px" }}
                    />
                  </span>
                </button>
              )}
            </div>

            <div className="collapse navbar-collapse" id="navbarCollapse">
              {!careerPage && (
                <ul className="navbar-nav mx-auto">
                  <li className="nav-item">
                    <a href="#homesections" data-scroll-nav={2}>
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#aboutsections" data-scroll-nav={2}>
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#servicesections" data-scroll-nav={2}>
                      Services
                    </a>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="dropdown-toggle"
                      href="#"
                      id="dropdownMenuButton3"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Portfolio
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton3"
                    >
                      <a href={DigitalRaizpdf} target="_blank">
                        Company Portfolio
                      </a>
                      <a href={DigitalraizCreativeSolutions} target="_blank">
                        Marketing Portfolio
                      </a>
                      <a href={MobilePortfolio} target="_blank">
                        Mobile App Portfolio
                      </a>
                    </div>
                  </li>
                  <li className="nav-item">
                    <Link to="/career">Carrer</Link>
                  </li>
                </ul>
              )}

              {!careerPage && (
                <a
                  className="btn themes-btn d-lg-inline d-none"
                  href="tel:+919494613601"
                >
                  <i
                    className="fa fa-phone blockHeader-callIcon"
                    aria-hidden="true"
                  ></i>{" "}
                  +91 9494 613 601
                </a>
              )}
            </div>

            {careerPage && (
              <a
                className="btn themes-btn d-lg-inline d-none ml-auto"
                href="tel:+919494613601"
              >
                <i
                  className="fa fa-phone blockHeader-callIcon"
                  aria-hidden="true"
                ></i>{" "}
                +91 9494 613 601
              </a>
            )}
          </div>
        </nav>
      </header>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="mt-5"
      >
        {/* <div onClick={handleClose}>
          <i class="fa fa-times modalstyle " aria-hidden="true" ></i>
        </div> */}
        <div className="row login-page ">
          <div className="col-md-5 mobileslider cross">
            <div className=" login-side-des">
              <div className="container-fluid">
                <div className="login-side-block">
                  <div className="row">
                    <div className="col-6">
                      <a href="">
                        <img src={logo} alt="Logo" />
                      </a>
                    </div>
                    <div className="col-6 ">
                      <p class="visible float-right" onClick={handleClose}>
                        .
                      </p>
                    </div>
                  </div>
                  <div className="login-reviews">
                    <div className="review-details-content">
                      <div
                        className="owl-carousel review_details"
                        id="review_details-2"
                      >
                        <Slider {...settings1}>
                          <div className="item">
                            <p>
                              "Our Dr.Narayana group of institutions were very
                              happy with digital raiz solutions.. very satisfied
                              with their work and response..."
                            </p>
                            <h5>Sravani Reddy</h5>
                            <h6>
                              Vice Princile of Dr.Narayana group of institutions
                            </h6>
                          </div>

                          <div className="item">
                            <p>
                              " Digital Raiz team developed a mobile app for me.
                              They are the best in app development more over
                              they save my money and time. I suggest Digital
                              Raiz for mobile app development."
                            </p>
                            <h5>Ganesh</h5>
                            <h6>Chairmen of TaxiGk</h6>
                          </div>

                          <div className="item">
                            <p>
                              "Best website design company in Hyderabad...I am
                              on of the client in Digital Raiz creative
                              solutions, its a good customer services. our
                              project will done at limited. Thankyou digital
                              Raiz creative solutions for your support."
                            </p>
                            <h5>Abdullah</h5>
                            <h6>CEO of Iotroncs</h6>
                          </div>

                          <div className="item">
                            <p>
                              "Digital Raiz made a website and mobile app for
                              us. Product is excellent and their support is
                              outstanding. Thanks to staff and management."
                            </p>
                            <h5> Bhupesh </h5>
                            <h6>Md of SLN Services</h6>
                          </div>

                          <div className="item">
                            <p>
                              "Very efficient and reliable team. Definitely
                              recommend Digital Raiz Creative Solutions for
                              those who are looking for digital marketing
                              services within budget and on time. Excellent
                              client services and support provided. Thanks
                              Team!"
                            </p>
                            <h5>Bala Koteshwara Rao</h5>
                            <h6>MD of Thrilokmart</h6>
                          </div>

                          <div className="item">
                            <p>
                              "They procure a Very Good team in digital
                              marketing and web development. I recommend my
                              customers to join hands with Digital Raiz"
                            </p>
                            <h5>Sai Kiran</h5>
                            <h6>MD of Vedithtech</h6>
                          </div>
                          <div className="item">
                            <p>
                              "Good quality best team members in time pra
                              project submission.......Thank You DigitalRaiz."
                            </p>
                            <h5>Manikanta</h5>
                            <h6>Chairmen of SMV Chemical</h6>
                          </div>
                          <div className="item">
                            <p>
                              "DigitalRaiz developed my app name SIFALO, within
                              time at a low cost. I suggested this company for
                              mobile applications. "
                            </p>
                            <h5>Khalil Ahmed</h5>
                            <h6>Somalia VP of Sifalo</h6>
                          </div>
                          <div className="item">
                            <p>
                              "We were truly impressed! The way digital Raiz
                              developed my mobile application in the name of
                              EXMOB, with less cost, on-time delivery, and
                              finally, the way of conducting meetings and
                              gathering the requirement was excellent. Thank you
                              so much, digital raiz team."
                            </p>
                            <h5>Nawaz</h5>
                            <h6>Chairmen of EXMOB</h6>
                          </div>
                          <div className="item">
                            <p>
                              "One of the best digital marketing agencies to
                              generate potential leads through google ads is
                              DigitalRaiz. Good Job Done."
                            </p>
                            <h5>Nawaf</h5>
                            <h6>UAE</h6>
                          </div>
                          <div className="item">
                            <p>
                              "We have hired them for our Mobile application
                              development work, They are productive and punctual
                              in work they have completed our new mobile
                              application very quickly. I truly recommend the
                              digital raiz for abroad clients."
                            </p>
                            <h5>Branty Bruno</h5>
                            <h6>France CEO of Decohindi</h6>
                          </div>
                        </Slider>
                      </div>
                    </div>
                    <p class="visible" onClick={handleClose}>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-7">
            <div className="container">
             <div className="res-logo">
               <div className="row ">
                <div className="col-6">
                  <a href="">
                    <img src={logo} alt="Logo" />
                  </a>
                </div>
                <div className="col-6">
                  <p class="visible float-right" onClick={handleClose}>
                    .
                  </p>
                </div>
              </div>
             </div>

              <div className="login-form modheight">
                <div className="row">
                  <div className="login-form-head col-12">
                    <h3 className="">
                      <span className="h2txt">Welcome to</span>{" "}
                      <span>DigitalRaiz</span>
                    </h3>
                    <p>Fill out the form to get started..</p>
                  </div>
                  {/* <div className="col-2 mt-2">
                    <div
                      type="button"
                      style={{ cursor: "pointer" }}
                      onClick={handleClose}
                    >
                      <i class="fa fa-times modalstyle " aria-hidden="true"></i>
                    </div>
                  </div> */}
                </div>

                <form onSubmit={usersSubmit}>
                  <div className="row">
                    <div className=" col-md-6 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinEmail">
                        Full Name <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-user-o" />
                        </div>
                        <input
                          type="text"
                          pattern="^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$"
                          className="form-control"
                          name="name"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          id="signinEmail"
                          placeholder="Full Name"
                          aria-label="Email address"
                          required
                        />
                      </div>
                    </div>
                    <div className=" col-md-6 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinPassword">
                        Mobile <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-mobile" />
                        </div>
                        <input
                          type="text"
                          minlength="0"
                          maxlength="10"
                          pattern="\d{10}"
                          className="form-control"
                          name="phone"
                          id="signinPassword"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          placeholder="Mobile No..."
                          aria-label="Password"
                          required
                        />
                      </div>
                    </div>
                    <div className=" col-md-12 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinPassword2">
                        {" "}
                        Email Id
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-envelope-o" />
                        </div>
                        <input
                          type="email"
                          pattern="(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)"
                          className="form-control"
                          name="email"
                          id="signinPassword2"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          placeholder="Email Id"
                          aria-label="Password"
                        />
                      </div>
                    </div>
                    <div className=" col-md-12 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinPassword2">
                        DigitalRaiz Services <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <select
                          className="form-control"
                          value={form.service}
                          name="service"
                          id="signinPassword2"
                          placeholder="Email Id"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          aria-label="Password"
                          required
                        >
                          <option value="">Select</option>
                          <option value="Mobile Application">
                            Mobile Application
                          </option>
                          <option
                            className="form-control"
                            value="Website Design & Development"
                          >
                            Website Design & Development
                          </option>
                          <option
                            className="form-control"
                            cvalue="Digital Marketing"
                          >
                            Digital Marketing
                          </option>
                          <option
                            className="form-control"
                            cvalue="eCommerce Application"
                          >
                            eCommerce Application
                          </option>
                          <option
                            className="form-control"
                            cvalue="Food Delivery Application"
                          >
                            Food Delivery Application
                          </option>
                          <option className="form-control" cvalue="Others">
                            Others
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-2 col-md-12 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinPassword2">
                        Planning
                        <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-calendar" />
                        </div>
                        <select
                          className="form-control"
                          value={form.lookingfor}
                          name="lookingfor"
                          id="signinPassword2"
                          placeholder="Email Id"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          aria-label="Password"
                          required
                        >
                          <option value="">Select</option>
                          <option value="Immediately">Immediately</option>
                          <option className="form-control" value="15 Days">
                            15 Days
                          </option>
                          <option className="form-control" cvalue="30 Days">
                            30 Days
                          </option>
                          <option
                            className="form-control"
                            cvalue="Just Looking"
                          >
                            Just Looking
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className=" col-md-6 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinEmail23">
                        Your Project Name <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-suitcase" />
                        </div>
                        <input
                          type="text"
                          pattern="^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$"
                          className="form-control"
                          name="projectname"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          id="signinEmail23"
                          placeholder="Your Project Name"
                          aria-label="Email address"
                          required
                        />
                      </div>
                    </div>
                    <div className=" col-md-6 col-sm-12 p-1">
                      <label className="form-label" htmlFor="signinEmail25">
                        Location <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-map-marker" />
                        </div>
                        <input
                          type="text"
                          pattern="^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$"
                          className="form-control"
                          name="location"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          id="signinEmail25"
                          placeholder="Location"
                          aria-label="Email address"
                          required
                        />
                      </div>
                    </div>
                    <div className=" col-12 p-1 mb-2">
                      <label className="form-label" htmlFor="aboutProject">
                        About Your Project <a className="text-danger">*</a>
                      </label>
                      <div className="input-group">
                        <div className="input-icon">
                          <span className="fa fa-comments" />
                        </div>
                        <textarea
                          className="form-control"
                          name="aboutproject"
                          onChange={(e) => {
                            handlechange(e);
                          }}
                          id="aboutProject"
                          placeholder="Brief Description"
                          aria-label="About Your Project"
                          required
                          style={{ height: "80px" }}
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button className="btn theme-btn btn-block" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
                {/* <p class="visible" onClick={handleClose}>
                  .
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
}

export default Header;
